import Image from "next/image";
import { BlockProps } from "../BlocksManager/registry";

import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

function renderMarkedTitle(title: string, highlightClass: string) {
    const parts = title.split(/(\[.*?\])/g);
    return parts.map((part, index) => {
        const isHighlighted = part.startsWith("[") && part.endsWith("]");
        if (isHighlighted) {
            const text = part.slice(1, -1);
            return (
                <span
                    key={index}
                    className={`inline-block font-heading  text-black ${highlightClass}`}
                >
                    {text}
                </span>
            );
        }

        return <span key={index}>{part}</span>;
    });
}


export default function BoissonsSection({ data }: BlockProps) {
    if (!data) return null;
    const items = data?.boissons || [];

    const [currentDrinkIndex, setCurrentDrinkIndex] = useState(0);

    const goDrinkLeft = () => {
        setCurrentDrinkIndex((prev) => Math.max(0, prev - 1));
    };

    const goDrinkRight = () => {
        setCurrentDrinkIndex((prev) => Math.min(items.length - 1, prev + 1));
    };
    return (
        <section className="bg-white py-10 lg:py-16 container" key={data.id}>
            <div className="mx-auto max-w-[1400px]">
                <div className="mx-auto max-w-[900px] text-center">

                    <h2 className="font-display text-[30px] font-bold leading-tight text-text-body ">

                        {renderMarkedTitle(data.titre, "text-[34px] lg:text-[60px]")}
                    </h2>
                </div>

                {/* Mobile : carousel */}
                <div className="mt-14 md:hidden">
                    <div className="overflow-hidden">
                        <div
                            className="flex transition-transform duration-300 ease-in-out"
                            style={{ transform: `translateX(-${currentDrinkIndex * 100}%)` }}
                        >
                            {items.map((item: any, index: number) => {
                                const bgClass =
                                    index % 2 === 0 ? "bg-yellow-light" : "bg-violet-light";

                                return (
                                    <div key={item.id} className="w-full shrink-0 px-2">
                                        <article
                                            className={[
                                                "relative mx-auto flex h-[400px] w-full max-w-[320px] flex-col items-center rounded-[343px] px-8 pb-10 pt-10 text-center",
                                                bgClass,
                                            ].join(" ")}
                                        >
                                            {/* zone image fixe */}
                                            <div className="relative h-[200px] w-[140px] shrink-0">
                                                <Image
                                                    src={item.image.url}
                                                    alt={item.imageAlt || item.nom}
                                                    fill
                                                    className="object-contain object-center"
                                                />
                                            </div>

                                            {/* zone titre fixe et centrée */}
                                            <div className="flex items-center justify-center">
                                                <h3 className="font-heading max-w-[250px] text-center text-[30px] font-medium leading-[1.2] text-black">
                                                    {item.nom}
                                                </h3>
                                            </div>
                                        </article>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Navigation */}
                    {items.length > 1 && (
                        <div className="mt-6 flex items-center justify-center gap-6">
                            <button
                                type="button"
                                onClick={goDrinkLeft}
                                disabled={currentDrinkIndex === 0}
                                className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md disabled:opacity-30"
                                aria-label="Boisson précédente"
                            >
                                <ChevronLeft className="h-5 w-5 text-black" />
                            </button>

                            <div className="flex gap-2">
                                {items.map((_: any, i: number) => (
                                    <button
                                        key={i}
                                        type="button"
                                        onClick={() => setCurrentDrinkIndex(i)}
                                        className={`h-2.5 w-2.5 rounded-full transition-all ${i === currentDrinkIndex ? "bg-pink w-5" : "bg-blue/30"
                                            }`}
                                        aria-label={`Aller à la boisson ${i + 1}`}
                                    />
                                ))}
                            </div>

                            <button
                                type="button"
                                onClick={goDrinkRight}
                                disabled={currentDrinkIndex === items.length - 1}
                                className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-md disabled:opacity-30"
                                aria-label="Boisson suivante"
                            >
                                <ChevronRight className="h-5 w-5 text-black" />
                            </button>
                        </div>
                    )}
                </div>

                {/* Desktop : affichage actuel */}
                <div className="mt-14 hidden flex-col items-center justify-center md:flex md:flex-row md:items-end">
                    {items.map((item: any, index: number) => {
                        const bgClass = index % 2 === 0 ? "bg-yellow-light" : "bg-violet-light";

                        return (
                            <article
                                key={item.id}
                                className={[
                                    "relative flex h-[400px] w-full max-w-[320px] flex-col items-center rounded-[343px] px-8 pb-10 pt-10 text-center lg:h-[460px]",
                                    bgClass,
                                    index > 0 ? "md:-ml-8" : "",
                                ].join(" ")}
                            >
                                {/* zone image fixe */}
                                <div className="relative h-[200px] w-[140px] shrink-0 md:h-[280px] md:w-[200px]">
                                    <Image
                                        src={item.image.url}
                                        alt={item.imageAlt || item.nom}
                                        fill
                                        className="object-contain object-center"
                                    />
                                </div>

                                {/* zone titre fixe et centrée */}
                                <div className="flex items-center justify-center">
                                    <h3 className="font-heading max-w-[250px] text-center text-[30px] font-medium leading-[1.2] text-black">
                                        {item.nom}
                                    </h3>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}